<template>
	<div class="stats-cell" :style="slotStyle" :class="slotClass" @click="doAction">
		<div class="stats-label">{{ cell.label }}</div>
		<template v-if="cell.perc">
			<div v-if="cell.base" class="stats-perc stats-lessimportant">({{ cell.perc }})</div>
			<div v-else class="stats-perc" :style="cell.percStyle">{{ cell.perc }}</div>
		</template>
		<div v-if="cell.count" class="stats-num">{{ cell.count }}<span v-if="cell.countOf" class="stats-of">/{{ cell.countOf }}</span></div>
		<form-help v-if="cell.help" :value="cell.help" for="fld" dt="standard" :above="true"></form-help>
	</div>
</template>

<script setup lang="ts">
import {ref, computed, CSSProperties} from "vue";
import {SlotContent} from "@fd/editors/charts/StatsSupport.ts";
import FormHelp from "@fd/components/FormHelp.vue";

const props = defineProps<{
	cell: SlotContent
}>();

const emit = defineEmits(["action"]);

const slotStyle = computed<CSSProperties|null>(() => {
	if (props.cell.span > 1) return { gridColumn: "span "+props.cell.span };
	return null;
});

const slotClass = computed<string|null>(() => {
	if (props.cell.action || props.cell.href) return "stats-cell-action";
	return null;
});

async function doAction() {
	if (props.cell.action || props.cell.href) emit("action", props.cell);
}

</script>
